import { useState } from "react"

// components
import {
	Container,
	Grid,
	IconButton,
	Popover,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
} from "@material-ui/core"
import InfoIcon from "@material-ui/icons/Info"
import { PitchTypeChip } from "../../../shared/PitchTypeChip"

// types
import { InPlayStats } from "./StatsTab"

interface Props {
	inPlayStats: InPlayStats[]
}

export const InPlayTable = ({ inPlayStats }: Props) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
	inPlayStats = inPlayStats.filter(
		(pitch) =>
			pitch.groundballPct !== 0 ||
			pitch.linedrivePct !== 0 ||
			pitch.flyballPct !== 0
	)
	return (
		<Paper className="padding-top-12 padding-bottom-24">
			<Container>
				<Grid container spacing={0}>
					<Grid item xs={8}>
						<h2>In Play</h2>
					</Grid>
					<Grid
						item
						xs={4}
						className="align-right"
						style={{ marginTop: "10px" }}>
						<IconButton
							onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
								setAnchorEl(event.currentTarget)
							}>
							<InfoIcon />
						</IconButton>
						<Popover
							open={Boolean(anchorEl)}
							anchorEl={anchorEl}
							onClose={() => setAnchorEl(null)}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "center",
							}}>
							<Container
								className="padding-top-24 padding-bottom-24"
								maxWidth="sm">
								<Grid container spacing={0}>
									<Grid item xs={12}>
										HitHard%:
									</Grid>
									<Grid item xs={12}>
										<ul>
											<li>
												When this pitch gets put in play, how often it ends up
												being hit hard
											</li>
										</ul>
									</Grid>
									<Grid item xs={12}>
										GB%:
									</Grid>
									<Grid item xs={12}>
										<ul>
											<li>
												When this pitch gets put in play, how often it ends up
												being a ground ball
											</li>
										</ul>
									</Grid>
									<Grid item xs={12}>
										LD%:
									</Grid>
									<Grid item xs={12}>
										<ul>
											<li>
												When this pitch gets put in play, how often it ends up
												being a line drive
											</li>
										</ul>
									</Grid>
									<Grid item xs={12}>
										FB%:
									</Grid>
									<Grid item xs={12}>
										<ul>
											<li>
												When this pitch gets put in play, how often it ends up
												being a fly ball
											</li>
										</ul>
									</Grid>
								</Grid>
							</Container>
						</Popover>
					</Grid>
				</Grid>
				<TableContainer>
					<Table size="small">
						<TableHead>
							<TableRow className="table-header">
								<TableCell align="center">Type</TableCell>
								<TableCell align="center">HitHard%</TableCell>
								<TableCell align="center">GB%</TableCell>
								<TableCell align="center">LD%</TableCell>
								<TableCell align="center">FB%</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{inPlayStats.map((pitch, index) => (
								<TableRow key={index}>
									<TableCell align="center">
										<PitchTypeChip pitchType={pitch.type} />
									</TableCell>
									<TableCell align="center">
										{pitch.hitHardPct.toFixed(0)}%
									</TableCell>
									<TableCell align="center">
										{pitch.groundballPct.toFixed(0)}%
									</TableCell>
									<TableCell align="center">
										{pitch.linedrivePct.toFixed(0)}%
									</TableCell>
									<TableCell align="center">
										{pitch.flyballPct.toFixed(0)}%
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Container>
		</Paper>
	)
}
